export enum FilterSizingType {
    Default = '',
    FullWidth = '-sh-is-full-width',
    Growable = '-sh-is-growable'
}
